import queryString from 'query-string'
import PCLNAnalytics from '@pcln/analytics'
import { customHistory } from './routerHistory'
import { clientErrorRedirect } from '../../helpers/clientErrorRedirect'

const SLICES_ROOT = '/m/fly/search/:slices(\\w{3}-\\w{3}-\\d{8})+'

class RoutingHelper {
  constructor(history = customHistory) {
    this.history = history
  }

  static routePaths = {
    filters: [`${SLICES_ROOT}/filter`],
    listings: [SLICES_ROOT],
  }

  /**
   * Returns true if instance has a valid browser history object
   * @returns {boolean}
   * @private
   */
  __checkHistory = () => {
    if (!this.history || !this.history.location) {
      // eslint-disable-next-line no-console
      console.error('RoutingHelper was not initialized with a browser history. Skipping transition.')
      return false
    }

    return true
  }

  __getSlicesURLRoot = () => {
    // Remove non-slice nodes from pathname
    const regex = /^\S*\/m\/fly\/search\/(([a-z]+\/)?)(?:\w{3}-\w{3}-\d{8}\/)+/g
    const found = this.history.location.pathname.match(regex)

    return found ? found[0] : null
  }

  /**
   * Navigate from Listings to Filter route
   */
  goToFilters = () => {
    if (!this.__checkHistory()) return

    // parse query params
    const params = queryString.parse(this.history.location.search)

    const listingsPathname = this.__getSlicesURLRoot()

    if (listingsPathname) {
      // navigate to listings with same query params
      this.history.push({
        pathname: `${listingsPathname}filter`,
        search: queryString.stringify(params),
      })
    } else {
      const message = `Error navigating to Filters from ${this.history.location.pathname}`
      PCLNAnalytics.logError({
        message,
      })
      // new relic error
      window?.newrelic?.noticeError(message)
      clientErrorRedirect()
    }
  }
}

const navigateToFiltersPage = (history) => {
  if (!history?.push) return

  history.push(
    `${
      history.location.pathname.match(/^\S*\/m\/fly\/search\/(([a-z]+\/)?)(?:\w{3}-\w{3}-\d{8}\/)+/g)[0]
    }filter${history.location.search}`
  )
}

const navigateToListingsPage = (history) => {
  if (!history?.push) return

  history.push(
    `${history.location.pathname.match(/^\S*\/m\/fly\/search\/(([a-z]+\/)?)(?:\w{3}-\w{3}-\d{8}\/)+/g)[0]}${
      history.location.search
    }`
  )
}

export { RoutingHelper, navigateToFiltersPage, navigateToListingsPage }
